import { createAction, handleActions } from "redux-actions";

import { constants as authLoginConstants } from "../auth/login";

export const SET_ASK_FIRST_NAME_DONT_SHOW_AT =
  "app/askFirstNamePrompt/SET_ASK_FIRST_NAME_DONT_SHOW_AT";

export const setAskFirstNameDontShowAt = createAction(
  SET_ASK_FIRST_NAME_DONT_SHOW_AT,
  () => ({
    dontShowAt: Math.floor(Date.now() / 1000)
  })
);

const initialState = {
  dontShowAt: null
};

export default handleActions(
  {
    [SET_ASK_FIRST_NAME_DONT_SHOW_AT]: (state, { payload }) => ({
      ...state,
      dontShowAt: payload.dontShowAt
    }),
    [authLoginConstants.LOGOUT_AFTER]: () => initialState
  },
  initialState
);
